export default function ScrollToTop(anchor = "main", container, hidden = true) {
  /*
  <a href="#" class="scrollToTop">
    <i class="fa-solid fa-angle-up scrollToTop__icon"></i>
    <span class="u-srOnly">Back to </span>Top
  </a>
   */
  const button = document.createElement("a");
  button.classList.add("scrollToTop");
  button.setAttribute("href", `#${anchor}`);
  const icon = document.createElement("i");
  icon.classList.add("fa-solid", "fa-angle-up", "scrollToTop__icon");
  const span = document.createElement("span");
  span.classList.add("u-srOnly");
  span.innerText = "Back to ";
  const text = document.createTextNode("Top");
  button.appendChild(icon);
  button.appendChild(span);
  button.appendChild(text);

  if (!hidden) {
    button.classList.add("scrollToTop--visible");
  }

  container.appendChild(button);

  return button;
}
